import { useRef } from "react";

/**
 * True only while a query loads for the first time. Later loads (for example a
 * new query key after a date change) return false, so callers can keep the
 * page mounted and the focused control in place.
 */
export function useIsInitialLoad(isLoading: boolean, hasData: boolean): boolean {
  const hasLoadedRef = useRef(false);
  if (hasData) {
    hasLoadedRef.current = true;
  }
  return isLoading && !hasLoadedRef.current;
}

export default useIsInitialLoad;
